(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["blue-top-menu"]) return;
  try {
    
jQuery(function() {

  var deviceMenuNarrowWidth = 12;

  // If products menus overlap right hand screen edge, move their positions to the left
  // We need to set left position because we are using overflow-x on device menu, otherwise pure css would do.
  var positionProductMenus = function($menu) {
    var pageRight = $('body').offset().left + $('body').outerWidth();
    
    $('.blue-device-menu-item', $menu).each(function(i, e) {
      var parentLeft = $(e).offset().left;      
      $('.blue-device-menu-product-wrapper', $(e)).each(function(i, e) {
        var right = parentLeft + $(e).outerWidth();
        if (right > pageRight) {
          $(e).offset(function(i, o) {
            return({ left: parentLeft - (right - pageRight), top: o.top});
          });
        } else {
          $(e).offset(function(i, o) { return { left: parentLeft, top: o.top }; });
        }
      });      
    });
  };
  
  // Show or hide buttons based on scroll view
  var checkButtonVisibility = function($menu, totalWidth) {
    var $ul = $('ul.blue-device-menu-items', $menu);
    if ($ul.scrollLeft() > 0) {
      $menu.addClass('blue-device-menu--has-left-button');      
    } else {
      $menu.removeClass('blue-device-menu--has-left-button');      
    }
    if ($ul.scrollLeft() < (totalWidth - $ul.width()) ) {
      $menu.addClass('blue-device-menu--has-right-button');            
    } else {
      $menu.removeClass('blue-device-menu--has-right-button');                  
    }

    // Check for partially hidden menu items
    var left = 0;
    var wrapperWidth = $('.blue-device-menu-wrapper', $menu).width();
    var scrollLeft = $ul.scrollLeft();
    $('li.blue-device-menu-item', $menu).each(function(i, e) {
      var width = $(e).width();
      var widthBy2 = width / 2;

      if ((left + width - widthBy2) < scrollLeft || (left + widthBy2) > wrapperWidth + scrollLeft) {
        $(e).addClass('blue-top-menu-item--overflowed');
      } else {
        $(e).removeClass('blue-top-menu-item--overflowed');
      }
      left = left + width;
    });

  };
  

  var leftButtonClicked = function(ev, $menu, totalWidth) {
    ev.preventDefault();
    var $ul = $('ul.blue-device-menu-items', $menu);
    $ul.animate({ scrollLeft: $ul.scrollLeft() - $menu.width() }, function() {
      checkButtonVisibility($menu, totalWidth);    
      positionProductMenus($menu);
    });
  };
  
  var rightButtonClicked = function(ev, $menu, totalWidth) {
    ev.preventDefault();
    var $ul = $('ul.blue-device-menu-items', $menu);
    $ul.animate({ scrollLeft: $ul.scrollLeft() + $menu.width() }, function() {
      checkButtonVisibility($menu, totalWidth);      
      positionProductMenus($menu);
    });
  };
  
  // If the device menu is too wide to fit, switch to a sliding view
  var deviceMenuNeedsScroll = function() {
    $('#blue-top-menu .blue-top-wrapper .blue-device-menu').each(function(i, e) {
      var $menu = $(e);

      // Work out width of all device menu items
      var totalWidth = 0;
      $('li.blue-device-menu-item', $menu).each(function(i, e) {
        totalWidth = totalWidth + $(e).width();
      });

      // Check if it needs scrolling support
      if (totalWidth > $('.blue-device-menu-wrapper', $menu).width()) {
        $menu.addClass('blue-device-menu--has-scroll');
        $('ul.blue-device-menu-items', $menu).on('scroll', function(ev) { 
          checkButtonVisibility($menu, totalWidth); 
          positionProductMenus($menu);
        });

        // Append left/right buttons
        if (!$menu.hasClass('blue-device-menu--has-buttons')) {
          $menu.addClass('blue-device-menu--has-buttons');
          $('.blue-device-menu-wrapper', $menu).append('<div class="blue-device-menu-buttons"><div class="blue-device-menu-left-button"><a href="#"></a></div><div class="blue-device-menu-right-button"><a href="#"></a></div></div>');
          $('.blue-device-menu-left-button a', $menu).on('click', function(ev) { leftButtonClicked(ev, $menu, totalWidth); });
          $('.blue-device-menu-right-button a', $menu).on('click', function(ev) { rightButtonClicked(ev, $menu, totalWidth); });    
        }
        
        checkButtonVisibility($menu, totalWidth);
      } else {
        $menu.removeClass('blue-device-menu--has-scroll');
      }
    });
  };

  // Mark device menu items as narrow if they don't have much text
  var setNarrowDeviceItems = function() {
    $('#blue-top-menu .blue-top-wrapper .blue-device-menu').each(function(i, e) {
      var $menu = $(e);
      if (!$menu.hasClass('blue-device-menu--set-narrow')) {
        $menu.addClass('blue-device-menu--set-narrow');
        $('li.blue-device-menu-item', $menu).each(function(i, e) {
          if ($('> a', $(e)).text().length < deviceMenuNarrowWidth) {
            $(e).addClass('blue-device-menu--is-narrow');
          }
        });   
      }
    });
  };
 
  // Do stuff based on screen size  
  var resize = function() {
    setNarrowDeviceItems();
    deviceMenuNeedsScroll();
    $('#blue-top-menu .blue-top-wrapper .blue-device-menu').each(function(i, menu) {
      positionProductMenus($(menu));
    });
  };
  
  resize();
  $(window).resize(resize);

  $('a.blue-menu-no-click').click(function(ev) { ev.preventDefault(); });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daily-deals-tag-selector"]) return;
  try {
    

$(function() {

  var loadPage = function(loadURL) {
    var $container = $('#shopify-section-daily-deals-tag-selector');
    $container.addClass('tags-loading');
    $.ajax({ 
      url: loadURL,
      data: { 'section_id': 'daily-deals-tag-selector' },
      dataType: 'html',
      type: 'GET',
      success: function(data) {
        $container.replaceWith(data);
        $container.removeClass('tags-loading');
        history.pushState({ }, "", loadURL);
        var elem = $(".DailyDealsTagSelector")[0];
        var rect = elem.getBoundingClientRect();
        if (rect.top < 0) {
          $(".DailyDealsTagSelector")[0].scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
        }

      },
      error: function() {
        window.location = loadURL;
      }
    });
  }

  console.log("HASH: " + window.location.hash);
  console.log("selected: " + $(".DailyDealsTagSelector select").attr("value"));
  if (window.location.hash == "") {
    loadPage($(".DailyDealsTagSelector select").attr("value"));
  }
  $(".DailyDealsTagSelector select").live('change', function() {
    loadPage($(this).attr("value"));
  });

  $(".DailyDealsTagSelector .tagselect-page-button").live('click', function(ev) {
    ev.preventDefault();
    loadPage($(this).attr("href"));
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-colour-swatches"]) return;
  try {
    

$(function() {

  var loadPage = function(loadURL) {
    var $container = $('#shopify-section-product-colour-swatches');
    $container.addClass('tags-loading');
    $.ajax({ 
      url: loadURL,
      data: { 'section_id': 'product-colour-swatches' },
      dataType: 'html',
      type: 'GET',
      success: function(data) {
        $container.replaceWith(data);
        $container.removeClass('tags-loading');
      },
      error: function() {
        window.location = loadURL;
      }
    });
  }

  $("#shopify-section-product-colour-swatches").live('change', function() {
    loadPage(window.location);
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-tag-selector"]) return;
  try {
    

$(function() {
  $(".TestTagSelector select").live('change', function() {
    var getURL = $(this).attr("value");
    var $container = $('#shopify-section-test-tag-selector');
    $container.addClass('tags-loading');
    $.ajax({ 
      url: getURL,
      data: { 'section_id': 'test-tag-selector' },
      dataType: 'html',
      type: 'GET',
      success: function(data) {
        $container.replaceWith(data);
        $container.removeClass('tags-loading');
        history.pushState({ }, "", getURL);
      },
      error: function() {
        window.location = getURL;
      }
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test-top-menu"]) return;
  try {
    
jQuery(function() {

  var deviceMenuNarrowWidth = 12;

  // If products menus overlap right hand screen edge, move their positions to the left
  // We need to set left position because we are using overflow-x on device menu, otherwise pure css would do.
  var positionProductMenus = function($menu) {
    var pageRight = $('body').offset().left + $('body').outerWidth();
    
    $('.blue-device-menu-item', $menu).each(function(i, e) {
      var parentLeft = $(e).offset().left;      
      $('.blue-device-menu-product-wrapper', $(e)).each(function(i, e) {
        var right = parentLeft + $(e).outerWidth();
        if (right > pageRight) {
          $(e).offset(function(i, o) {
            return({ left: parentLeft - (right - pageRight), top: o.top});
          });
        } else {
          $(e).offset(function(i, o) { return { left: parentLeft, top: o.top }; });
        }
      });      
    });
  };
  
  // Show or hide buttons based on scroll view
  var checkButtonVisibility = function($menu, totalWidth) {
    var $ul = $('ul.blue-device-menu-items', $menu);
    if ($ul.scrollLeft() > 0) {
      $menu.addClass('blue-device-menu--has-left-button');      
    } else {
      $menu.removeClass('blue-device-menu--has-left-button');      
    }
    if ($ul.scrollLeft() < (totalWidth - $ul.width()) ) {
      $menu.addClass('blue-device-menu--has-right-button');            
    } else {
      $menu.removeClass('blue-device-menu--has-right-button');                  
    }
  };
  
  var leftButtonClicked = function(ev, $menu, totalWidth) {
    ev.preventDefault();
    var $ul = $('ul.blue-device-menu-items', $menu);
    $ul.animate({ scrollLeft: $ul.scrollLeft() - $menu.width() }, function() {
      checkButtonVisibility($menu, totalWidth);    
      positionProductMenus($menu);
    });
  };
  
  var rightButtonClicked = function(ev, $menu, totalWidth) {
    ev.preventDefault();
    var $ul = $('ul.blue-device-menu-items', $menu);
    $ul.animate({ scrollLeft: $ul.scrollLeft() + $menu.width() }, function() {
      checkButtonVisibility($menu, totalWidth);      
      positionProductMenus($menu);
    });
  };
  
  // If the device menu is too wide to fit, switch to a sliding view
  var deviceMenuNeedsScroll = function() {
    $('#TestTopMenu .blue-top-wrapper .blue-device-menu').each(function(i, e) {
      var $menu = $(e);

      // Work out width of all device menu items
      var totalWidth = 0;
      $('li.blue-device-menu-item', $menu).each(function(i, e) {
        totalWidth = totalWidth + $(e).width();
      });

      // Check if it needs scrolling support
      if (totalWidth > $('.blue-device-menu-wrapper', $menu).width()) {
        $menu.addClass('blue-device-menu--has-scroll');
        $('ul.blue-device-menu-items', $menu).on('scroll', function(ev) { 
          checkButtonVisibility($menu, totalWidth); 
          positionProductMenus($menu);
        });

        // Append left/right buttons
        if (!$menu.hasClass('blue-device-menu--has-buttons')) {
          $menu.addClass('blue-device-menu--has-buttons');
          $('.blue-device-menu-wrapper', $menu).append('<div class="blue-device-menu-buttons"><div class="blue-device-menu-left-button"><a href="#"></a></div><div class="blue-device-menu-right-button"><a href="#"></a></div></div>');
          $('.blue-device-menu-left-button a', $menu).on('click', function(ev) { leftButtonClicked(ev, $menu, totalWidth); });
          $('.blue-device-menu-right-button a', $menu).on('click', function(ev) { rightButtonClicked(ev, $menu, totalWidth); });    
        }
        
        checkButtonVisibility($menu, totalWidth);
      } else {
        $menu.removeClass('blue-device-menu--has-scroll');
      }
    });
  };

  // Mark device menu items as narrow if they don't have much text
  var setNarrowDeviceItems = function() {
    $('#TestTopMenu .blue-top-wrapper .blue-device-menu').each(function(i, e) {
      var $menu = $(e);
      if (!$menu.hasClass('blue-device-menu--set-narrow')) {
        $menu.addClass('blue-device-menu--set-narrow');
        $('li.blue-device-menu-item', $menu).each(function(i, e) {
          if ($('> a', $(e)).text().length < deviceMenuNarrowWidth) {
            $(e).addClass('blue-device-menu--is-narrow');
          }
        });   
      }
    });
  };
 
  // Do stuff based on screen size  
  var resize = function() {
    setNarrowDeviceItems();
    deviceMenuNeedsScroll();
    $('#TestTopMenu .blue-top-wrapper .blue-device-menu').each(function(i, menu) {
      positionProductMenus($(menu));
    });
  };
  
  resize();
  $(window).resize(resize);

  $('a.blue-menu-no-click').click(function(ev) { ev.preventDefault(); });
  
  var nav = responsiveNav("#TestTopMenu-mobile-navigation", {});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vegan-tag-selector"]) return;
  try {
    

$(function() {

  var loadPage = function(loadURL) {
    var $container = $('#shopify-section-vegan-tag-selector');
    $container.addClass('tags-loading');
    $.ajax({ 
      url: loadURL,
      data: { 'section_id': 'vegan-tag-selector' },
      dataType: 'html',
      type: 'GET',
      success: function(data) {
        $container.replaceWith(data);
        $container.removeClass('tags-loading');
        history.pushState({ }, "", loadURL);
        var elem = $(".VeganTagSelector")[0];
        var rect = elem.getBoundingClientRect();
        if (rect.top < 0) {
          $(".VeganTagSelector")[0].scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
        }

      },
      error: function() {
        window.location = loadURL;
      }
    });
  }

  console.log("HASH: " + window.location.hash);
  console.log("selected: " + $(".VeganTagSelector select").attr("value"));
  if (window.location.hash == "") {
    loadPage($(".VeganTagSelector select").attr("value"));
  }
  $(".VeganTagSelector select").live('change', function() {
    loadPage($(this).attr("value"));
  });

  $(".VeganTagSelector .tagselect-page-button").live('click', function(ev) {
    ev.preventDefault();
    loadPage($(this).attr("href"));
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youtube-videos"]) return;
  try {
    

  $('.ytvClickable').click(function(e) {
    e.preventDefault();
    var $target = $(e.target).parent('a');
    var url = $target.data('url');
    if (url == undefined) {
      alert("No Youtube shortcode defined!")
    } else {
      $('.ytvThumbnail').removeClass('ytvCurrent');
      $target.parent('.ytvThumbnail').addClass('ytvCurrent');
      $('#ytvPlayer').attr('src', "https://www.youtube.com/embed/"+url+"?autoplay=1&rel=0&modestbranding=1");
    }
  });


  } catch(e) { console.error(e); }
})();

})();
